<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ $t('PluggedInNovaContent').title }}</h1>
    <div class="academics-text" v-html="$t('PluggedInNovaContent').text"></div>
    <div v-for="(protocol, p) in $t('PluggedInNovaContent').protocols" :key="p">
      <h2>{{ protocol.title }}</h2>
      <div>
        <v-row>
          <v-col
            v-for="(item, i) in protocol.items"
            :key="i"
            class="col-6 col-md-4 pt-0 px-5 pb-10"
          >
            <v-card flat outlined :href="item.link" target="_blank">
              <v-img
                height="180"
                contain
                :src="getImageURI(item.image)"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'pluggedInNova',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getImageURI(imageName) {
      if (imageName) {
        return require(`../../assets/images/protocols/${imageName}`)
      }
      return 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
    },
  },
}
</script>
